import { define } from '@owenscorning/pcb.alpha';
import _ from 'lodash';

export default define`Categories`('0.0.1')({
  raw: () => ({ Page: _.mapKeys(['Customizable', 'Prebuilt']) }),
});
